/**
 * 广告模块
 */
import adApi from '../../api/ad.api'
import _ from 'lodash'

const state = {
    adList: []
};

const getters = {
    getAdItem: state => type => {
        return _.filter(state.adList, item => {
            return item.type.key === type;
        });
    }
};

const mutations = {
    setAdItems(state, data) {
        state.adList = state.adList.concat(data);
    }
};

const actions = {
    // 获取对应类型的广告列表
    getItemByTypeKey({state, commit, getters}, params) {
        let exist = _.some(state.adList, item => {
            return (item.type || {}).key === params.type;
        });
        return exist ? getters.getAdItem(params.type) : adApi.getItemByTypeKey(params).then(res => {
            commit('setAdItems', res);
            return res;
        })
    },
    // 增加广告统计
    addAdClickCount({state, commit},params) {
        return adApi.addAdClickCount(params);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./app/store/modules/ad.js